import { FC, memo } from 'react'

import { useForm, useStore } from '@tanstack/react-form'
import { useMutation } from '@tanstack/react-query'
import { useRouter } from '@tanstack/react-router'
import { Request } from 'commons/utils/request/request'
import { FF, LeaveConfirmation, handleFormSubmissionError } from 'ui/components'
import { Dialog, DialogFace, DialogFooterActions } from 'ui/components/Dialog'
import { TextareaInput } from 'ui/components/InputV2'

import { PublicationNotesDialogProps } from './PublicationNotesDialog.types'

import { s } from './styles'

export const PublicationNotesDialog: FC<PublicationNotesDialogProps> = memo(({ publication, onClose }) => {
  const router = useRouter()
  const { id, notes, title } = publication

  const formApi = useForm({
    defaultValues: { notes: notes || '' },
    onSubmit: async ({ value: { notes } }) => {
      await saveNotes({ id, notes })
    }
  })

  const { mutateAsync: saveNotes } = useMutation<void, Error, { id: number; notes: string }>({
    mutationFn: (opts) => Request.patch(Request.urls.bank.adverseMediaPublicationChangeNotes, opts),
    onSuccess: async () => {
      formApi.reset()
      onClose()
      router.invalidate()
    },
    onError: async (error) => {
      handleFormSubmissionError(error, formApi)
    }
  })

  return (
    <Dialog
      face={DialogFace.PRIMARY}
      id="publication-notes-edit-dialog"
      onClose={onClose}
      title={<s.Title>{title}</s.Title>}
      subTitle="Edit Notes"
      footerActions={[DialogFooterActions.SAVE, DialogFooterActions.CANCEL]}
      onSubmit={() => formApi.handleSubmit()}
    >
      <LeaveConfirmation preventLeaving={useStore(formApi.store, (s) => s.isDirty)}>
        <s.Content>
          <formApi.Field
            name="notes"
            children={(field) => (
              <FF
                field={field}
                label="Notes"
                input={(inputProps) => <TextareaInput {...inputProps} style={{ height: '190px' }} />}
              />
            )}
          />
        </s.Content>
      </LeaveConfirmation>
    </Dialog>
  )
})
